module.exports = __webpack_public_path__ + "img/arrow-down.1d05e36b.svg";